(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Madison-ORC"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';

    const cards = [...root.querySelectorAll('.mad-orc__event')];
    const filters = [...root.querySelectorAll('[data-filter]')];
    const dateLabel = root.querySelector('[data-next-date]');
    const countdown = root.querySelector('[data-countdown]');
    const label = root.querySelector('.mad-orc__countdown-label');

    let selected = 'all';

    const refresh = () => {
      const now = Date.now();

      const upcoming = cards.filter(
        card => Date.parse(card.dataset.end) > now
      );

      cards.forEach(card => {
        card.hidden =
          Date.parse(card.dataset.end) <= now ||
          (
            selected !== 'all' &&
            card.dataset.kind !== selected
          );
      });

      root.querySelector('.mad-orc__empty').hidden =
        cards.some(card => !card.hidden);

      const next = upcoming[0];

      if (!next) {
        countdown.hidden = true;
        label.textContent = 'MORE RUNS AHEAD';
        dateLabel.textContent =
          'Follow @outruncomfort for the next event dates.';
        return;
      }

      /*
       * Haunted Hustle is intentionally listed without a specific
       * start time. When it becomes the next event, we show the
       * event date instead of a fake countdown to an arbitrary time.
       */
      if (next.dataset.allDay === 'true') {
        countdown.hidden = true;
        label.textContent = 'NEXT CLUB EVENT';
        dateLabel.textContent =
          next.querySelector('h3').textContent +
          ' · Monday, October 26';
        return;
      }

      countdown.hidden = false;

      const start = Date.parse(next.dataset.start);

      label.textContent = now >= start
        ? 'YOUR NEXT CLUB EVENT IS UNDERWAY'
        : 'NEXT CLUB EVENT STARTS IN';

      const remaining = Math.max(0, start - now);

      [
        ['days', 86400000],
        ['hours', 3600000],
        ['minutes', 60000],
        ['seconds', 1000]
      ].forEach(([key, unit], index) => {
        const value = index === 0
          ? Math.floor(remaining / unit)
          : Math.floor(remaining / unit) %
            (index === 1 ? 24 : 60);

        root.querySelector('[data-' + key + ']').textContent =
          String(value).padStart(2, '0');
      });

      dateLabel.textContent =
        next.querySelector('h3').textContent +
        ' · ' +
        new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/Chicago',
          weekday: 'long',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit'
        }).format(new Date(start));
    };

    filters.forEach(button => {
      button.addEventListener('click', () => {
        selected = button.dataset.filter;

        filters.forEach(filter => {
          filter.setAttribute(
            'aria-pressed',
            String(filter === button)
          );
        });

        refresh();
      });
    });

    refresh();

    const timer = window.setInterval(() => {
      if (!root.isConnected) {
        window.clearInterval(timer);
        return;
      }

      refresh();
    }, 1000);
  };

  const initializeAll = () => {
    document.querySelectorAll('.mad-orc').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeAll,
      { once: true }
    );
  } else {
    initializeAll();
  }

  document.addEventListener(
    'shopify:section:load',
    initializeAll
  );
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sooci-media"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('sooci-media')) {
  customElements.define('sooci-media', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.galleries = [];
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.querySelectorAll('[data-gallery]').forEach(gallery => {
        const track = gallery.querySelector('[data-track]');
        const slides = [...track.querySelectorAll('.sm-slide')];
        const prev = gallery.querySelector('[data-gallery-prev]');
        const next = gallery.querySelector('[data-gallery-next]');
        const play = gallery.querySelector('[data-play]');
        const state = { gallery, track, slides, visible: false, hovered: false, focused: false, playing: gallery.dataset.autoplay === 'true' && !reduced.matches && slides.length > 1 };
        const index = () => {
          const left = track.getBoundingClientRect().left;
          let nearest = 0;
          let distance = Infinity;
          slides.forEach((slide, i) => {
            const delta = Math.abs(slide.getBoundingClientRect().left - left);
            if (delta < distance) { distance = delta; nearest = i; }
          });
          return nearest;
        };
        const move = step => {
          if (slides.length < 2) return;
          let target;
          if (step > 0 && track.scrollLeft >= track.scrollWidth - track.clientWidth - 2) target = 0;
          else if (step < 0 && track.scrollLeft <= 2) target = slides.length - 1;
          else target = Math.max(0, Math.min(slides.length - 1, index() + step));
          const left = track.scrollLeft + slides[target].getBoundingClientRect().left - track.getBoundingClientRect().left;
          track.scrollTo({ left, behavior: reduced.matches ? 'auto' : 'smooth' });
        };
        const update = () => {
          if (!play) return;
          play.setAttribute('aria-pressed', String(state.playing));
          const label = state.playing ? play.dataset.pauseLabel : play.dataset.playLabel;
          play.setAttribute('aria-label', label);
          play.querySelector('[data-play-text]').textContent = label;
        };
        const pause = () => { state.playing = false; update(); };
        prev.hidden = next.hidden = slides.length < 2;
        if (play) { play.hidden = slides.length < 2; update(); play.addEventListener('click', () => { state.playing = !state.playing; update(); }, options); }
        prev.addEventListener('click', () => { pause(); move(-1); }, options);
        next.addEventListener('click', () => { pause(); move(1); }, options);
        track.addEventListener('pointerdown', pause, options);
        track.addEventListener('wheel', pause, { ...options, passive: true });
        track.addEventListener('keydown', event => {
          pause();
          if (event.target === track && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) {
            event.preventDefault();
            move(event.key === 'ArrowLeft' ? -1 : 1);
          }
        }, options);
        gallery.addEventListener('mouseenter', () => { state.hovered = true; }, options);
        gallery.addEventListener('mouseleave', () => { state.hovered = false; }, options);
        gallery.addEventListener('focusin', () => { state.focused = true; }, options);
        gallery.addEventListener('focusout', event => { state.focused = gallery.contains(event.relatedTarget); }, options);
        state.timer = setInterval(() => { if (state.playing && state.visible && !state.hovered && !state.focused && !document.hidden && !this.dialog?.open && !reduced.matches) move(1); }, 5000);
        this.galleries.push(state);
      });
      this.observer = new IntersectionObserver(entries => entries.forEach(entry => {
        const state = this.galleries.find(item => item.gallery === entry.target);
        if (state) state.visible = entry.isIntersecting;
      }), { threshold: 0.2 });
      this.galleries.forEach(state => this.observer.observe(state.gallery));
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || !this.dialog.showModal) return;
      this.large = this.querySelector('[data-large]');
      this.caption = this.querySelector('[data-caption]');
      this.count = this.querySelector('[data-count]');
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-photo]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.origin = link;
        this.photos = [...link.closest('[data-gallery]').querySelectorAll('[data-photo]')];
        this.index = this.photos.indexOf(link);
        this.showPhoto();
        this.dialog.showModal();
      }, options);
      this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close(), options);
      this.querySelector('[data-prev]').addEventListener('click', () => this.move(-1), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.move(1), options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); this.move(event.key === 'ArrowLeft' ? -1 : 1); }
      }, options);
      this.dialog.addEventListener('close', () => { this.large.removeAttribute('src'); if (this.origin?.isConnected) this.origin.focus(); }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      }, options);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.galleries?.forEach(state => clearInterval(state.timer));
      this.ready = false;
    }
    move(step) { this.index = (this.index + step + this.photos.length) % this.photos.length; this.showPhoto(); }
    showPhoto() {
      const photo = this.photos[this.index];
      this.large.alt = photo.dataset.caption || '';
      this.large.src = photo.href;
      this.caption.textContent = photo.dataset.caption || '';
      this.count.textContent = `${this.index + 1} / ${this.photos.length}`;
      this.querySelector('[data-prev]').hidden = this.photos.length < 2;
      this.querySelector('[data-next]').hidden = this.photos.length < 2;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whitwater-ORC"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.ww-orc');
    const formatter = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Chicago', weekday: 'short', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false });
    const chicagoParts = date => Object.fromEntries(formatter.formatToParts(date).filter(part => part.type !== 'literal').map(part => [part.type, part.value]));
    const offsetAt = date => {
      const part = chicagoParts(date);
      const wallTime = Date.UTC(Number(part.year), Number(part.month) - 1, Number(part.day), Number(part.hour) % 24, Number(part.minute), Number(part.second));
      return wallTime - date.getTime();
    };
    const chicagoDateToUTC = (year, month, day, hour) => {
      const guess = new Date(Date.UTC(year, month - 1, day, hour));
      return new Date(guess.getTime() - offsetAt(guess));
    };
    const nextRun = now => {
      const part = chicagoParts(now);
      const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      const weekday = weekdays.indexOf(part.weekday);
      let daysAhead = (6 - weekday + 7) % 7;
      const afterStart = Number(part.hour) > 11 || (Number(part.hour) === 11 && (Number(part.minute) > 0 || Number(part.second) > 0));
      if (daysAhead === 0 && afterStart) daysAhead = 7;
      const noon = new Date(Date.UTC(Number(part.year), Number(part.month) - 1, Number(part.day) + daysAhead, 12));
      return chicagoDateToUTC(noon.getUTCFullYear(), noon.getUTCMonth() + 1, noon.getUTCDate(), 11);
    };
    sections.forEach(section => {
      const days = section.querySelector('[data-days]');
      const hours = section.querySelector('[data-hours]');
      const minutes = section.querySelector('[data-minutes]');
      const seconds = section.querySelector('[data-seconds]');
      const dateLabel = section.querySelector('[data-next-date]');
      let target = nextRun(new Date());
      const render = () => {
        const now = new Date();
        if (now >= target) target = nextRun(now);
        const remaining = Math.max(0, target.getTime() - now.getTime());
        days.textContent = String(Math.floor(remaining / 86400000)).padStart(2, '0');
        hours.textContent = String(Math.floor((remaining % 86400000) / 3600000)).padStart(2, '0');
        minutes.textContent = String(Math.floor((remaining % 3600000) / 60000)).padStart(2, '0');
        seconds.textContent = String(Math.floor((remaining % 60000) / 1000)).padStart(2, '0');
        dateLabel.textContent = target.toLocaleDateString('en-US', { timeZone: 'America/Chicago', weekday: 'long', month: 'long', day: 'numeric' }).toUpperCase() + ' · 11:00 AM';
      };
      render();
      window.setInterval(render, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
